<script>
import moment from 'moment'
import { mapState } from 'vuex'
import BotTemplateDetail from '@/components/bot-template/BotTemplateDetail'
import ListView from '@/components/common/ListView'
import u from '@/utils'
import { botTemplateApi } from '../../api'

export default {
  data() {
    return {
      title: 'Bot Templates',
      searchAttributes: ['name', 'description', 'hexId'],
      selectedBotTemplate: null,
      initialFetchUpdating: false,
      refreshFetchUpdating: false,
      deleteUpdating: false,
      botTemplates: [],
      page: 1,
      totalPages: 0,
      pagination: {},
      base64EncFilter: '',
      totalItems: '',
      routeName: 'bot-template-list'
    }
  },

  computed: {
    ...mapState({
      // botTemplates: state => state.botTemplates.botTemplates,
      botTemplatesLoading: state => state.botTemplates.botTemplatesLoading
    }),
    updating() {
      return (
        this.botTemplatesLoading ||
        this.initialFetchUpdating ||
        this.refreshFetchUpdating ||
        this.deleteUpdating
      )
    }
  },

  watch: {
    selectedBotTemplate() {
      this.routeEdit()
    },
    botTemplates() {
      this.getSelectedFromRoute()
    },
    async $route(to, from) {
      const obj = this.getFiltersFromUrl()
      if (obj) {
        const filter = this.createFilters(obj)
        await this.makeApiCall(filter)
      }
    }
  },

  methods: {
    routeEdit() {
      if (this.selectedBotTemplate) {
        this.$router
          .replace({
            name: 'bot-template-detail',
            params: { hexId: this.selectedBotTemplate.hexId }
          })
          .catch()
      } else {
        this.$router
          .replace({
            name: 'bot-template-list',
            query: { filter: this.base64EncFilter }
          })
          .catch()
      }
    },

    getSelectedFromRoute() {
      if (this.$router.currentRoute.name === 'bot-template-detail') {
        if (this.botTemplates && this.botTemplates.length > 0) {
          this.selectedBotTemplate = this.botTemplates.find(botTemplate => {
            return botTemplate.hexId === this.$route.params.hexId
          })
        } else {
          this.$router
            .replace({
              name: 'bot-template-card',
              params: { hexId: this.$route.params.hexId }
            })
            .catch()
        }
      } else if (this.$router.currentRoute.name === 'bot-template-list') {
        if (this.botTemplates && this.botTemplates.length === 0) {
          this.refreshItem()
        }
      }
    },

    addBot() {
      this.$router.replace({ name: 'add-bot' }).catch()
    },

    botAddition() {
      this.$router.replace({ name: 'bot-addition' }).catch()
    },

    async deleteItem() {
      this.deleteUpdating = true
      try {
        // await this.$store.dispatch(
        //   'deleteBotTemplate',
        //   this.selectedBotTemplate.hexId
        // )
        await botTemplateApi.deleteBotTemplate(this.selectedBotTemplate.hexId)
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot Template deleted Successfully',
          description: `${this.selectedBotTemplate.hexId} has been deleted Successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.selectedBotTemplate = null
        // this.routeEdit()
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Bot Template deletion Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      try {
        await this.makeApiCall(this.createFilters(this.getFiltersFromUrl()))
        // await this.$store.dispatch('fetchBotTemplates')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot Template(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.deleteUpdating = false
    },

    getFiltersFromUrl() {
      const params = u.checkUrlHasFilters(this.$route)
      let obj
      if (params) {
        obj = {}
        this.page = +params.get('page')
        obj.page = +params.get('page')
      }
      if (params && params.has('search')) {
        obj.search = params.get('search')
      }
      if (params && params.has('sort')) {
        const sortStr = params.get('sort').split(',')
        obj.sortBy = sortStr[0]
        obj.sortOrder = sortStr[1]
      }
      this.pagination = obj
      return obj
    },

    createFilters(obj) {
      let search = null
      let sortBy
      let sortOrder
      if (obj) {
        if (obj.page) {
          this.page = obj.page
        }
        if (obj.search) {
          search = obj.search
        }
        if (obj.sortBy) {
          sortBy = obj.sortBy
          sortOrder = obj.sortOrder
        }
      }
      let filter = `?page=${this.page}&size=10`
      if (search) {
        filter = filter + `&search=${search}`
      }
      if (sortBy) {
        filter = filter + `&sort=${sortBy},${sortOrder}`
      }
      return filter
    },

    async makeApiCall(filter) {
      try {
        this.refreshFetchUpdating = true
        const { data } = await botTemplateApi.fetchBotTemplates(filter)
        if (data) {
          let botTemplates = data._embedded.botTemplates
          this.botTemplates = botTemplates.map(botTemplate =>
            u.processResp(botTemplate)
          )
          this.totalPages = data.page.totalPages
          this.totalItems = data.page.totalElements
        }
        this.refreshFetchUpdating = false
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Fetching bots failed',
          description:
            'Fetching bots failed - ' + e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },

    async refreshItem(obj, replace = false) {
      const filter = this.createFilters(obj)
      const condenseURL = btoa(filter)
      this.base64EncFilter = condenseURL
      if (replace || (obj && obj.replace)) {
        this.$router.replace({
          query: { filter: condenseURL },
          name: this.routeName
        })
        if (obj && obj.replace) {
          await this.makeApiCall(filter)
        }
      } else {
        this.$router.push({
          query: { filter: condenseURL },
          name: this.routeName
        })
      }
    }
  },

  async created() {
    if (this.$route.name === this.routeName) {
      const obj = this.getFiltersFromUrl()
      if (obj) {
        await this.makeApiCall(this.createFilters(obj))
      } else {
        this.refreshItem(obj, true)
      }
    } else {
      this.getSelectedFromRoute()
    }
  },

  components: {
    BotTemplateDetail,
    ListView
  }
}
</script>

<template>
  <list-view
    search
    :items="botTemplates"
    :title="title"
    :search-attributes="searchAttributes"
    item-key="hexId"
    v-model="selectedBotTemplate"
    refresh-action
    entity-type="BOT_TEMPLATE"
    delete-action
    create-action
    @create="addBot"
    @addition="botAddition"
    addition-action
    @delete="deleteItem"
    :updating="updating"
    @refresh="obj => refreshItem(obj)"
    :pagefromUrl="page"
    :totalPages="totalPages"
    :totalItems="totalItems"
    :pagination="pagination"
  >
    <template slot="list-item" slot-scope="slotProps">
      <div
        style="margin-right: 20px; height: 90%; width: 5px;"
        :class="
          selectedBotTemplate &&
          slotProps.item.hexId === selectedBotTemplate.hexId
            ? 'secondary'
            : 'grey'
        "
      ></div>
      <v-list-tile-content>
        <v-list-tile-title v-text="slotProps.item.name"></v-list-tile-title>
        <v-list-tile-sub-title
          v-html="slotProps.item.description"
        ></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
    <bot-template-detail
      slot="list-item-detail"
      slot-scope="slotProps"
      v-if="slotProps.item != null"
      :bot-template="slotProps.item"
    ></bot-template-detail>
  </list-view>
</template>
